import React from 'react';

export default function CustomerMatchWarning({ matches = [], onSelect, onIgnore }) {
  if (matches.length === 0) return null;

  return (
    <div style={{
      padding: '16px',
      background: '#fef3c7',
      border: '1px solid #fbbf24',
      borderRadius: '8px',
      marginBottom: '16px'
    }}>
      <div style={{
        fontSize: '14px',
        fontWeight: '600',
        color: '#92400e',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span style={{ fontSize: '18px' }}>⚠️</span>
        <span>Potential duplicate customer detected</span>
      </div>

      <div style={{
        fontSize: '13px',
        color: '#78350f',
        marginBottom: '12px'
      }}>
        Found {matches.length} existing customer{matches.length === 1 ? '' : 's'} with similar information:
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginBottom: '12px'
      }}>
        {matches.map((customer, index) => (
          <div
            key={index}
            style={{
              padding: '12px',
              background: 'white',
              border: '1px solid #fbbf24',
              borderRadius: '6px'
            }}
          >
            <div style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#2b2b2b',
              marginBottom: '4px'
            }}>
              {customer.name}
            </div>
            
            {customer.phone && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                📞 {customer.phone}
              </div>
            )}
            
            {customer.email && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                ✉️ {customer.email}
              </div>
            )}
            
            {customer.address && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                📍 {customer.address}
              </div>
            )}

            <button
              onClick={() => onSelect(customer)}
              style={{
                marginTop: '8px',
                padding: '6px 12px',
                background: '#8B4513',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Use This Customer
            </button>
          </div>
        ))}
      </div>

      <button
        onClick={onIgnore}
        style={{
          padding: '8px 16px',
          background: 'transparent',
          border: '1px solid #92400e',
          borderRadius: '6px',
          color: '#92400e',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
          width: '100%'
        }}
      >
        Continue with New Customer
      </button>
    </div>
  );
}